"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selection = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _Chip = _interopRequireDefault(require("@mui/material/Chip"));

var _Avatar = _interopRequireDefault(require("@mui/material/Avatar"));

var _Box = _interopRequireDefault(require("@mui/material/Box"));

var Selection = function Selection(_ref) {
  var data = _ref.data,
      selected = _ref.selected,
      onChange = _ref.onChange;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      rowGap: 0.5,
      columnGap: 0.5,
      flexWrap: 'wrap',
      listStyle: 'none',
      m: 0
    },
    component: "ul"
  }, data.map(function (elem) {
    return /*#__PURE__*/_react.default.createElement(_Chip.default, {
      color: "primary",
      size: "medium",
      key: elem.name,
      label: t(elem.name),
      onClick: function onClick() {
        return onChange(elem.id);
      },
      avatar: /*#__PURE__*/_react.default.createElement(_Avatar.default, null, t(elem.name.at(0).toUpperCase()), elem.name.at(1).toUpperCase()),
      variant: elem.id === selected ? 'filled' : 'outlined'
    });
  }));
};

exports.Selection = Selection;